import styled from "styled-components";

export const Heading = styled.h1`
  text-align: center;
  margin: 1% 0;
  font-size: 4vw;
  font-weight: 100;
  letter-spacing: 50%;
`;

export const Categoriescss = styled.div`
  margin: 0 8% 5% 8%;
  margin-bottom: 8rem;
  display: grid;
  grid-template-columns: auto auto auto;
`;
